import { Item } from '@shared/interfaces';
import { TFunction } from 'i18next';

export const formatRegistrationPlate = (registrationPlate: string) => {
  const trimedReg = registrationPlate.replace(/\s+/g, '').slice(0, 6);
  return `${trimedReg.slice(0, 3)} ${trimedReg.slice(3)}`;
};

export const translateColor = (t: TFunction, color: string) => {
  const colors: Record<string, string> = {
    red: t('red'),
    cyan: t('cyan'),
    gray: t('gray'),
    grey: t('gray'),
    blue: t('blue'),
    green: t('green'),
    white: t('white'),
    black: t('black'),
    yellow: t('yellow'),
    orange: t('orange'),
    silver: t('silver'),
    purple: t('purple'),
    brown: t('brown'),
  };

  return colors[color.toLocaleLowerCase()] ?? '--';
};

export const translateGearbox = (t: TFunction, gearbox: string) => {
  const gearboxes: Record<string, string> = {
    automatic: t('automatic'),
    manual: t('manual'),
  };

  return gearboxes[gearbox.toLocaleLowerCase()] ?? '--';
};

export const translateFuel = (t: TFunction, fuel: string) => {
  const fuels: Record<string, string> = {
    hybrid: t('hybrid'),
    petrol: t('petrol'),
    diesel: t('diesel'),
    methane: t('methane'),
    ethanol: t('ethanol'),
    electric: t('electric'),
    electric_hybrid: t('electric_hybrid'),
    electric_diesel: t('electric/diesel'),
    electric_petrol: t('electric/petrol'),
    plugin_hybrid: t('plugin_hybrid'),
    petrol_lpg: t('petrol/lpg'),
    petrol_ethanol: t('petrol/ethanol'),
    petrol_methane: t('petrol/methane'),
  };

  return fuels[fuel.toLocaleLowerCase()] ?? '--';
};

export const getVehicleFullName = (vehicle?: Item) => {
  return `${vehicle?.properties?.brand ?? ''} ${vehicle?.properties?.modelName ?? ''}`;
};
